import React from "react"
import { useController } from "react-hook-form"
import { FormFeedback, FormGroup } from "reactstrap"
import PropTypes from "prop-types"

function CheckboxRHF({
  control,
  name,
  label,
  id,
  classNames = {},
  ...otherProps
}) {
  const { field, fieldState } = useController({ control, name })
  const inputId = id ? id : `id-${Math.random()}`
  return (
    <FormGroup className={classNames.group}>
      <div className="form-check form-check-primary">
        <input
          type="checkbox"
          className={`form-check-input ${classNames.input}`}
          name={name}
          id={inputId}
          defaultChecked={field.value}
          {...field}
          {...otherProps}
        />
        <label
          className={`form-check-label ${classNames.label}`}
          htmlFor={inputId}
        >
          {label}
        </label>
      </div>
      {fieldState.error ? (
        <FormFeedback className={classNames.feedback}>
          {fieldState.error.message}
        </FormFeedback>
      ) : null}
    </FormGroup>
  )
}
CheckboxRHF.propTypes = {
  label: PropTypes.string,
  control: PropTypes.object,
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  classNames: PropTypes.shape({
    group: PropTypes.string,
    label: PropTypes.string,
    input: PropTypes.string,
    feedback: PropTypes.string,
  }),
}
export default CheckboxRHF
